import React from 'react';
import ReactDOM from 'react-dom';
import Game from './components/Game';
import './styles.css';

ReactDOM.render(<Game />, document.getElementById("root"));